export default "__VITE_ASSET__D38_U_8___"